import { Outlet } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import MobileRedirect from '../components/MobileRedirect';

export default function AuthLayout() {
	const navigate = useNavigate();
	return (
		<Auth0Provider
			domain={import.meta.env.VITE_AUTH0_DOMAIN || ''}
			clientId={import.meta.env.VITE_AUTH0_CLIENTID || ''}
			authorizationParams={{
				audience: import.meta.env.VITE_AUTH0_AUDIENCE,
				redirect_uri: import.meta.env.VITE_AUTH0_CALLBACK_URL,
			}}
			onRedirectCallback={(appState) => {
				const returnTo = (appState as { returnTo?: string } | undefined)?.returnTo;
				navigate(returnTo || window.location.pathname, { replace: true });
			}}
		>
			<MobileRedirect />
			<Outlet />
		</Auth0Provider>
	);
}
